import { render, staticRenderFns } from "./AddPerformanceModal.vue?vue&type=template&id=d6497342&scoped=true&"
import script from "./AddPerformanceModal.vue?vue&type=script&lang=js&"
export * from "./AddPerformanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPerformanceModal.vue?vue&type=style&index=0&id=d6497342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6497342",
  null
  
)

export default component.exports